export default "__VITE_ASSET__a7493a88__"